import { RunState } from "../state/RunState";
import { STAGES, StageConfigEntry } from "../data/StageConfig";

export class StageSystem {
  getCurrentConfig(state: RunState): StageConfigEntry {
    const idx = Math.min(state.stageIndex, STAGES.length - 1);
    return STAGES[idx];
  }

  /** Returns true if promoted to next stage */
  checkPromotion(state: RunState): boolean {
    const config = this.getCurrentConfig(state);
    if (
      state.stageScore >= config.stageScoreThreshold &&
      state.stageIndex < STAGES.length - 1
    ) {
      state.stageIndex += 1;
      state.stageScore = 0;
      return true;
    }
    return false;
  }

  initStageTimer(state: RunState): void {
    const config = this.getCurrentConfig(state);
    state.timeRemainingMs = config.timeLimitSec * 1000;
    state.hits = 0;
  }
}
